<template>
  <div class="text-center">
    <img
      :class="fit === 'height' ? 'logo-fit-height' : 'logo-fit-width'"
      :src="src"
      alt="Logos"
    />
  </div>
</template>

<script>
export default {
  name: 'FilledImage',
  props: {
    src: {
      require: true,
      type: String,
    },
    fit: {
      type: String,
      default: 'width',
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-fit-width {
  width: 100%;
  height: auto;
  object-fit: cover;
}
.logo-fit-height {
  width: auto;
  min-height: 100%;
  object-fit: cover;
  max-width: 100%;
}
</style>
